module.exports = __webpack_public_path__ + "img/dr-mario-min.21a1f5ed.png";